/* eslint-disable no-cond-assign */
/* eslint-disable no-case-declarations */
import Slugify from 'slugify'
export default class {
  constructor (configurator) {
    this.configurator = configurator
  }

  encode () {
    return btoa(JSON.stringify(this.configurator.summary()))
  }

  slugify (string) {
    return Slugify(string, { lower: true })
  }

  serialize () {
    const convert = this.slugify
    const definition = []

    const activeSteps = this.configurator.getActiveSteps()
    activeSteps.forEach(step => {
      const stepDefinition = []
      switch (step.type) {
        case 'dimension_glass':
          const options = this.configurator.steps.find(s => s.model_step).options
          const option = options.find(o => o.selected)
          if (option && option.dimension) {
            const w = option.dimension.width.value + 'x'
            const l = option.dimension.length.value + 'x'
            const h1 = option.dimension.height.value + 'x'
            const h2 = typeof option.dimension.height_additional !== 'undefined' ? option.dimension.height_additional.value : null
            let param = ''
            if (h2 === null) {
              param = w + l + h1
            } else {
              param = w + l + h1 + h2
            }
            stepDefinition.push(param)
          }
          break
        case 'dimension_awnings':
          const opts = this.configurator.steps.find(s => s.model_step).options
          const opt = opts.find(o => o.selected)
          if (opt && opt.dimension) {
            const w = opt.dimension.width.value + 'x'
            const l = opt.dimension.length.value + 'x'
            const param = w + l
            stepDefinition.push(param)
          }
          break
        case 'color':
          stepDefinition.push(convert(step.colors.find(c => c.selected).name))
          break
        case 'quantity':
          stepDefinition.push(step.value)
          break
        case 'simpleselect':
        case 'simpletechnic':
        case 'montage_step':
        case 'color_roof':
        case 'glass':
        case 'conditional':
          step.options.forEach(option => {
            if (option.selected) {
              stepDefinition.push(convert(option.name))
            } else if (option.type === 'count' && !option.disabled) {
              stepDefinition.push(convert(option.name) + '[' + option.value + ']')
            }
          })
          break
      }
      definition.push(convert(step.name) + ':' + stepDefinition.join(','))
    })
    return definition.join(';')
  }

  selectOption (step, optionValue) {
    console.log(step, optionValue)
  }

  getStep ({ name }) {
    return this.configurator.steps.find(s => Slugify(s.name, { lower: true }) === name)
  }

  getSystemStep ({ name }) {
    return this.configurator.base.steps.find(s => Slugify(s.name, { lower: true }) === name)
  }

  deserialize (definition) {
    const parameters = this.parseDefinition(definition)

    if (parameters.length > 0) {
      parameters.forEach(({ step: stepName, value: values }) => {
        const step = this.getStep({ name: stepName })
        if (step) {
          values.forEach(value => {
            switch (step.type) {
              case 'color':
                let color
                if (color = step.colors.find(c => Slugify(c.name, { lower: true }) === value)) {
                  this.configurator.selectColor(step, color)
                }
                break
              case 'simpleselect':
              case 'simpletechnic':
              case 'glass':
              case 'color_roof':
              case 'conditional':
                let option
                if (option = step.options.find(c => Slugify(c.name, { lower: true }) === value)) {
                  this.configurator.selectOption(step, option)
                }
                break
              case 'dimension_glass':
                const dim = value.split('x')
                const w = Number.parseInt(dim[0])
                const l = Number.parseInt(dim[1])
                const h = Number.parseInt(dim[2])
                const h2 = typeof dim[3] !== 'undefined' ? dim[3] : ''
                this.configurator.setDimension(step, 'width', w)
                this.configurator.setDimension(step, 'height', h)
                this.configurator.setDimension(step, 'length', l)
                if (h2) {
                  this.configurator.setDimension(step, 'height_additional', h2)
                }
                break
              case 'dimension_awnings':
                const dimx = value.split('x')
                const wd = Number.parseInt(dimx[0])
                const lg = Number.parseInt(dimx[1])
                this.configurator.setDimension(step, 'width', wd)
                this.configurator.setDimension(step, 'length', lg)
                break
            }
          })
        }
      })
    }
  }

  parseDefinition (definition) {
    const data = []

    if (!definition) {
      return data
    }

    definition.split(';').forEach(part => {
      const parts = part.split(':')

      data.push({
        step: parts[0].toLowerCase(),
        value: parts[1].split(',').map(val => {
          return val.toLowerCase()
        })
      })
    })

    return data
  }
}
